import React, { useState } from 'react';
import styles from '../../styles/MediaCard.module.scss';
import { VideoThumb } from '../JobList';
import LightBox from './Lightbox';

const MediaCard = ({
  type, // 'image' | 'video' | 'audio
  url,
  name,
  viewOnly = false,
  onSelect,
  onClear,
  onPickerOpen,
  canSelect = true,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  return (
    <div className={`${styles.mediaCard} ${styles[type]} ${viewOnly ? styles.viewOnly : ''}`}>
      <div className={styles.previewBox}>
        {type === 'image' && <img src={url} alt={name} onClick={onSelect} />}
        {type === 'audio' && <audio controls preload="none" src={url} />}
        {type === 'video' && (
          <VideoThumb
            url={url}
            name={name}
            onClick={() => {
              setPreviewOpen(true);
            }}
            displayName={false}
          />
        )}
      </div>
      <div className={styles.previewHead}>
        <div className={styles.previewName} title={name}>
          {name}
        </div>
        {!viewOnly && (
          <div className={styles.previewActions}>
            {!!onPickerOpen ? (
              <button type="button" className="shake__btnPrimary" onClick={onPickerOpen}>
                Change
              </button>
            ) : (
              <button
                type="button"
                className="shake__btnPrimary"
                onClick={onSelect}
                disabled={!canSelect}
              >
                Select
              </button>
            )}
            {type !== 'audio' && (
              <button
                type="button"
                className="shake__btnGhost"
                onClick={() => setPreviewOpen(true)}
              >
                Preview
              </button>
            )}
            {onClear && (
              <button type="button" className="shake__btnGhost" onClick={onClear}>
                Clear
              </button>
            )}
          </div>
        )}
      </div>
      {previewOpen && (
        <LightBox
          type={type}
          url={url}
          name={name}
          onClose={() => setPreviewOpen(false)}
          onSelect={() => {
            onSelect();
            setPreviewOpen(false);
          }}
          displaySelect={canSelect}
        />
      )}
    </div>
  );
};

export default MediaCard;
